<script setup lang="ts">
import { computed } from 'vue';

import VButton from '@components/buttons/VButton/VButton.vue';
import {
  ADMIN_DOWNLOAD_REPORT_LIST_ROUTE_NAME,
  AFFILIATE_DOWNLOAD_REPORT_LIST_ROUTE_NAME,
  TRANSLATION_GROUP_DOWNLOAD_REPORT_BUTTON,
} from '@modules/download-report/constants';
import { useCurrentNamespace } from '@modules/permissions/composables';
import { TRANSLATION_GROUP_SIDEBAR } from '@modules/sidebar/constants';

const { isAdminNamespace } = useCurrentNamespace();

const menuItemShortCode = computed(() => (
  isAdminNamespace.value ? 'ADMIN_EXPORT_DOWNLOAD_CSV' : 'AFFILIATE_EXPORT_DOWNLOAD_CSV'
));
</script>

<template>
  <PToast
    position="bottom-right"
    group="download-report"
  >
    <template #message>
      <div
        class="flex flex-1 flex-wrap items-center gap-2"
      >
        <div class="text-base">
          {{ $getTranslation(TRANSLATION_GROUP_DOWNLOAD_REPORT_BUTTON, 'CREATE_REPORT_SUCCESS') }}
        </div>
        <VButton
          :label="$getTranslation(TRANSLATION_GROUP_SIDEBAR, menuItemShortCode)"
          :to="{
            name: isAdminNamespace ? ADMIN_DOWNLOAD_REPORT_LIST_ROUTE_NAME : AFFILIATE_DOWNLOAD_REPORT_LIST_ROUTE_NAME,
          }"
        />
      </div>
    </template>
  </PToast>
</template>
